import React, { useRef, useMemo } from "react";

import Button from '@/components/tangerina/Button';

import { TCard } from '@/services/requests/Recommendation/types/template8';
import { formatNumber } from '@/helpers/StringHelper/formatNumber';

type TProps = {
  prefixTemplateClass: string;
  card: TCard;
  splitMilesText: (text: string | undefined) => {
    numberPart: string;
    unitPart: string;
  };
}

export default function TableRow({ prefixTemplateClass, card, splitMilesText }: TProps) {
  const cardRef = useRef<HTMLTableRowElement>(null);

  const [
    departure,
    destination,
    date,
    miles,
  ] = card.card_text;

  const { numberPart, unitPart } = splitMilesText(miles.text);

  const handleButtonClick = () => {
    if (window.openModal) {
      window.openModal(cardRef.current as HTMLElement);
    }
  }

  const purchaseUrl = useMemo(() => {
    const airportFrom = card.header_1 || null;
    const airportTo = card.header_2 || null;

    const flightDateStr = card.card_text?.[2]?.text || null;
    let flightDate: number | null = null;
    if (flightDateStr) {
      const dateParts = flightDateStr.split('-');
      if (dateParts.length === 3) {
        const dateObj = new Date(
          Number(dateParts[0]),
          Number(dateParts[1]) - 1,
          Number(dateParts[2]),
          12,
          0,
          0,
          0
        );

        flightDate = dateObj.getTime();
      }
    }

    return `?originAirport=${airportFrom}&destinationAirport=${airportTo}&departureDate=${flightDate}&isFlexibleDateChecked=false`;
  }, [card.header_1, card.header_2, card.card_text?.[2]?.text]);

  const dateFormatted = useMemo(() => {
    if (!date.text) return null;
    const [year, month, day] = date.text.split('-');
    return `${day}/${month}/${year}`;
  }, [date.text]);

  return (
    <tr key={`card-${JSON.stringify(card.card_text)}-desktop`} ref={cardRef} data-purchase-url={purchaseUrl}>
      {/* Origem */}
      <td className={`${prefixTemplateClass}__table__data`}>
        <tgr-text-description>{departure.text}</tgr-text-description>
      </td>

      {/* Destino */}
      <td className={`${prefixTemplateClass}__table__data`}>
        <tgr-text-description>{destination.text}</tgr-text-description>
      </td>

      {/* Data do voo */}
      <td className={`${prefixTemplateClass}__table__data`}>
        <div
          className={`${prefixTemplateClass}__table__data__container__line1`}
        >
          <div
            className={`${prefixTemplateClass}__table__data__container__line1__text`}
          >
            {date.image?.url && (
              <img src={date.image.url} alt="calendar icon" />
            )}
            <tgr-text-description>{dateFormatted}</tgr-text-description>
          </div>
        </div>
      </td>

      {/* Preço */}
      <td className={`${prefixTemplateClass}__table__data`}>
        <div
          className={`${prefixTemplateClass}__table__data__container__line1`}
        >
          <div className={`${prefixTemplateClass}__table__data__price`}>
            <tgr-text-heading size="sm">
              <span className="miles-number">
                {formatNumber(numberPart)}
              </span>
            </tgr-text-heading>
            <tgr-text-description>
              <span className="miles-unit">{unitPart}</span>
            </tgr-text-description>
          </div>
          {miles?.tag_text && (
            <span
              className={`${prefixTemplateClass}__table__tag ${prefixTemplateClass}__table__tag--${miles.tag_color ?? 'default'
                }`}
            >
              {miles.tag_text}
            </span>
          )}
        </div>
        <div
          className={`${prefixTemplateClass}__table__data__container__line2`}
        >
          <tgr-text-description>{miles?.subtexto}</tgr-text-description>
        </div>
      </td>

      {/* Botão */}
      <td className={`${prefixTemplateClass}__table__data`}>
        <Button appearance="primary" onClick={handleButtonClick}>{card.card_link.label}</Button>
      </td>
    </tr>
  )
}
